import { useTranslation } from 'react-i18next';
import { useModalsContext } from '../../../../providers/ModalsProvider/Modals.context.ts';
import { useSocketsContext } from '../../../../providers/SocketsProvider/Sockets.context.ts';
import { useEffect, useState } from 'react';
import { eDeleteFunnelProgressModal } from './DeleteFunnelProgressModal.enum.ts';
import './DeleteFunnelProgressToast.styles.scss';
import { eFunnelDeletedProgressEvent } from './eFunnelDeletedProgressEvent.enum.ts';

export default function DeleteFunnelProgressToast() {
  const { setShowDeleteFunnelModal } = useModalsContext();
  const { funnelDeletedProgressEvent } = useSocketsContext();
  const { t } = useTranslation('pipe/funnel');
  const [progress, setProgress] = useState<number>(0);
  const [errorProgress, setErrorProgress] = useState<string | null>(null);

  funnelDeletedProgressEvent.useSubscription((data) => {
    if (data.response.progress == eFunnelDeletedProgressEvent.LEADS) {
      setProgress(33);
      setErrorProgress(null);
    } else if (data.response.progress == eFunnelDeletedProgressEvent.MOVED) {
      setProgress(66);
      setErrorProgress(null);
    } else if (data.response.progress == eFunnelDeletedProgressEvent.DELETED) {
      setProgress(100);
      setErrorProgress(null);
    } else {
      setErrorProgress(t('components.DeleteFunnelProgress.toaster.error'));
    }
  });

  useEffect(() => {
    if (progress > 99) {
      setShowDeleteFunnelModal(eDeleteFunnelProgressModal.SUCCESS);
    }
  }, [progress]);

  return (
    <div className="DeleteFunnelProgressToaster">
      <div className="DeleteFunnelProgressToaster__Container">
        <div className="DeleteFunnelProgressToaster__Container__Header">
          {errorProgress !== null
            ? errorProgress
            : t('components.DeleteFunnelProgress.toaster.title')}{' '}
          {progress} %
        </div>
      </div>

      <div className="DeleteFunnelProgressToaster__Container__Bottom">
        <div
          className="DeleteFunnelProgressToaster__Container__Bottom__ProgresBar"
          style={{
            width: `${progress}%`,
          }}
        ></div>
      </div>
    </div>
  );
}
